// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signal34-my-tags h1 {
  font-size: 18pt;
  margin-top: 20px;
  margin-bottom: 10px;
}

.signal34-my-tags {
  padding-left: 60px;
  padding-right: 60px;
}

@media only screen and (max-width: 767px) {
  .signal34-my-tags {
    padding-left: 8px;
    padding-right: 8px;
  }
}

div[class^="col-"]:first-child {
  padding-left:0px;
  padding-right: 0px;
}

.react-bootstrap-table-pagination-list {
  padding-left:0px;
  padding-right: 0px;
}

.react-bootstrap-table td{
  padding: 4px;
  color:var(--primaryTextColor);
}

.react-bootstrap-table thead{
  color:var(--primaryTextColor);
}


.table-striped > tbody > tr:nth-of-type(2n+1) > * {
  background-color: var(--signal34TagsTableTBodyColor);
  color: var(--primaryTextColor);
}



.btn-tag-rename {
  height: 30px;
  width: 34px;
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
}

.btn-tag-rename:hover,
.btn-tag-rename:focus,
.btn-tag-delete:hover,
.btn-tag-delete:focus {
  color:black;
}

.btn-tag-delete {
  height: 30px;
  width: 34px;
  color: #fff;
}

.btn-group {
  margin-left: 5px;
}

.tags-dropdown-button {
  position: absolute;
}

.tags-dropdown-button button {
  width:54px;
  height: 34px;
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonHoverBackgroundColor);
  border-color: #ccc;
}

.tags-dropdown-button button:hover,
.tags-dropdown-button button:focus,
.dropdown-toggle.btn-secondary:active:hover {
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonHoverBackgroundColor);
  border-color:  var(--signal34ButtonHoverBorderColor);
}

.btn-delete-tag {
  height: 34px;
  width: 48px;
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
  font-size: 14px;
}

.btn-delete-tag.btn-danger:hover,
.btn-delete-tag.btn-danger:focus,
.btn-delete-tag.btn-danger:active:hover {
  color:#fff;
  background-color:#c9302c;
  border-color:#ac2925;
}

.btn-no-delete-tag {
  height: 34px;
  width: 48px;
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonBackgroundColor);
  border-color: var(--signal34ButtonBorderColor);
  font-size: 14px;
}

.btn-no-delete-tag:hover,
.btn-no-delete-tag:focus,
.btn-no-delete-tag.btn-secondary:active:hover {
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonHoverBackgroundColor);
  border-color:  var(--signal34ButtonHoverBorderColor);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Tags.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,oDAAoD;EACpD,8BAA8B;AAChC;;;;AAIA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;;;EAGE,qCAAqC;EACrC,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,sDAAsD;EACtD,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;;;EAGE,qCAAqC;EACrC,2DAA2D;EAC3D,oDAAoD;AACtD","sourcesContent":[".signal34-my-tags h1 {\n  font-size: 18pt;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.signal34-my-tags {\n  padding-left: 60px;\n  padding-right: 60px;\n}\n\n@media only screen and (max-width: 767px) {\n  .signal34-my-tags {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n}\n\ndiv[class^=\"col-\"]:first-child {\n  padding-left:0px;\n  padding-right: 0px;\n}\n\n.react-bootstrap-table-pagination-list {\n  padding-left:0px;\n  padding-right: 0px;\n}\n\n.react-bootstrap-table td{\n  padding: 4px;\n  color:var(--primaryTextColor);\n}\n\n.react-bootstrap-table thead{\n  color:var(--primaryTextColor);\n}\n\n\n.table-striped > tbody > tr:nth-of-type(2n+1) > * {\n  background-color: var(--signal34TagsTableTBodyColor);\n  color: var(--primaryTextColor);\n}\n\n\n\n.btn-tag-rename {\n  height: 30px;\n  width: 34px;\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n\n.btn-tag-rename:hover,\n.btn-tag-rename:focus,\n.btn-tag-delete:hover,\n.btn-tag-delete:focus {\n  color:black;\n}\n\n.btn-tag-delete {\n  height: 30px;\n  width: 34px;\n  color: #fff;\n}\n\n.btn-group {\n  margin-left: 5px;\n}\n\n.tags-dropdown-button {\n  position: absolute;\n}\n\n.tags-dropdown-button button {\n  width:54px;\n  height: 34px;\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonHoverBackgroundColor);\n  border-color: #ccc;\n}\n\n.tags-dropdown-button button:hover,\n.tags-dropdown-button button:focus,\n.dropdown-toggle.btn-secondary:active:hover {\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonHoverBackgroundColor);\n  border-color:  var(--signal34ButtonHoverBorderColor);\n}\n\n.btn-delete-tag {\n  height: 34px;\n  width: 48px;\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  font-size: 14px;\n}\n\n.btn-delete-tag.btn-danger:hover,\n.btn-delete-tag.btn-danger:focus,\n.btn-delete-tag.btn-danger:active:hover {\n  color:#fff;\n  background-color:#c9302c;\n  border-color:#ac2925;\n}\n\n.btn-no-delete-tag {\n  height: 34px;\n  width: 48px;\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonBackgroundColor);\n  border-color: var(--signal34ButtonBorderColor);\n  font-size: 14px;\n}\n\n.btn-no-delete-tag:hover,\n.btn-no-delete-tag:focus,\n.btn-no-delete-tag.btn-secondary:active:hover {\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonHoverBackgroundColor);\n  border-color:  var(--signal34ButtonHoverBorderColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
